import React, { PropsWithChildren } from "react";
import { styled } from "styled-components";

import SecondaryThemePreview from "./SecondaryThemePreview";
import PrimaryThemePreview from "./PrimaryThemePreview";
import TertiaryThemePreview from "./TertiaryThemePreview";
import ModalPreviews from "./ModalPreviews";
import ButtonPreviews from "./ButtonPreviews";
import SurfacePreviews from "./SurfacePreviews";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  overflow: scroll;
  background: #e2e2e2;
  padding: 20px;
  flex-wrap: wrap;
  height: calc(100vh - 74px);
`;

const PreviewContainer = styled.div`
  flex-direction: row;
  align-items: flex-start;
`;

type PreviewWrapperProps = PropsWithChildren<{
  title: string;
}>;

function PreviewWrapper({ children, title }: PreviewWrapperProps) {
  return (
    <PreviewContainer>
      <h2>{title}</h2>
      {children}
    </PreviewContainer>
  );
}

export default function Previews() {
  return (
    <Container>
      <PreviewWrapper title="Primary">
        <PrimaryThemePreview />
      </PreviewWrapper>
      <PreviewWrapper title="Secondary">
        <SecondaryThemePreview />
      </PreviewWrapper>
      <PreviewWrapper title="Tertiary">
        <TertiaryThemePreview />
      </PreviewWrapper>
      <PreviewWrapper title="Popups">
        <ModalPreviews />
      </PreviewWrapper>
      <PreviewWrapper title="Components">
        <ButtonPreviews />
        <SurfacePreviews />
      </PreviewWrapper>
    </Container>
  );
}
